export class Phone {
    areaCode: string;
    city: string;
    country: string;
    countryCode: string;
    department: string;
    ext: string;
    phoneNumber: string;
    type: string;

    constructor() {
        this.areaCode = "";
        this.city = "";
        this.country = "";
        this.countryCode = "";
        this.department = "";
        this.ext = "";
        this.phoneNumber = "";
        this.type = "";
    }
}